import type { LandingPillSelectOption } from "../components/LandingPillSelect";
import type { LandingCourse } from "../types/landing.types";

/** Same label shown on CatalogCourseCard overlay badge */
export function getCourseAudienceBadge(
  course: LandingCourse
): string | undefined {
  const label = (course.audienceLabel ?? course.ageLabel)?.trim();
  return label || undefined;
}

/** Unique audience badges from the courses currently in this catalog listing */
export function collectCatalogAgeOptions(
  courses: LandingCourse[]
): LandingPillSelectOption[] {
  const labels = new Set<string>();

  for (const course of courses) {
    const badge = getCourseAudienceBadge(course);
    if (badge) {
      labels.add(badge);
    }
  }

  return [...labels]
    .sort((a, b) => a.localeCompare(b))
    .map((label) => ({ label, value: label }));
}

export function courseMatchesAgeFilter(
  course: LandingCourse,
  ageFilter: string
): boolean {
  if (!ageFilter) return true;
  return getCourseAudienceBadge(course) === ageFilter;
}
